import { CloseIcon } from '@/assets';
import { Dialog, DialogPanel } from '@headlessui/react';

interface ScheduleIframeDialogProps {
  show: boolean;
  onCloseCallback: () => void;
  iFrameMeetingLink: string | null;
}

export const ScheduleIframeDialog = ({
  show,
  onCloseCallback,
  iFrameMeetingLink,
}: ScheduleIframeDialogProps) => {
  return (
    <Dialog open={show} onClose={onCloseCallback} className="relative z-50">
      <div className="fixed inset-0 flex justify-center items-center p-4">
        <div
          className="fixed inset-0 bg-black bg-opacity-40 z-40"
          onClick={onCloseCallback}
        ></div>
        <DialogPanel className="relative w-full max-w-3xl z-50">
          {iFrameMeetingLink && (
            <div className="flex justify-center items-center w-full h-full">
              <div className="relative">
                <iframe
                  src={iFrameMeetingLink}
                  className="max-w-lg meetings-iframe-container"
                  style={{ width: '425px', height: '658px' }}
                  onClick={(e) => e.stopPropagation()}
                ></iframe>
                <button
                  className="text-base font-normal hover:font-bold hover:shadow-link-button link-text-shadow cursor-pointer"
                  aria-label="close-icon"
                  onClick={onCloseCallback}
                >
                  <div className="absolute top-1 right-0 text-white">
                    <div className="bg-white bg-opacity-40 border border-white border-opacity-50 backdrop-blur-md rounded-full p-1 transition-all duration-300 hover:bg-opacity-70 hover:border-opacity-50">
                      <CloseIcon width={24} height={24} fill="black" />
                    </div>
                  </div>
                </button>
              </div>
            </div>
          )}
        </DialogPanel>
      </div>
    </Dialog>
  );
};
